import { DIALOG_DATA, DialogRef } from '@angular/cdk/dialog';
import { Component, inject } from '@angular/core';
import { TranslateDirective } from '@foundation/translations/services';
import { AccessTableComponent } from '../access-table/access-table.component';

export interface AccessShareModalData {
	resourceId: string;
	resourceKind: string;
	hideAnonymous?: boolean;
}

@Component({
	selector: 'lib-access-share-modal',
	standalone: true,
	imports: [AccessTableComponent, TranslateDirective],
	templateUrl: './access-share-modal.component.html',
	styles: [
		`
			:host {
				display: block;
			}
		`,
	],
})
export class AccessShareModalComponent {
	private _dialogRef = inject<DialogRef<void, AccessShareModalComponent>>(DialogRef);
	public data = inject<AccessShareModalData>(DIALOG_DATA);

	close() {
		this._dialogRef.close();
	}
}
